import { AxiosRequestConfig } from "axios";
import { create } from "zustand";
import { AuthState } from "./types";

export interface RetryTransaction {
  url: string;
  data: any;
  config?: AxiosRequestConfig;
  method: "put" | "post" | "get" | "delete";
}

export interface IAuthState {
  isRefreshing: boolean;
  setIsRefreshing: (isRefreshing: boolean) => void;

  lastFailedRoute: string | undefined;
  setLastFailedRoute: (val: string | undefined) => void;

  authState: AuthState | null;
  setAuthState: (val: AuthState) => void;

  privileges: string[];
  setPrivilege: (val: string[]) => void;

  // queue: RetryTransaction[];
  // addToQueue: (tx: RetryTransaction) => void;
  // removeFromQueue: (index: number) => void;
  // clearQueue: () => void;
}

const authStore = create<IAuthState>((set) => ({
  isRefreshing: false,
  setIsRefreshing: (isRefreshing: boolean) => set({ isRefreshing }),

  lastFailedRoute: undefined,
  setLastFailedRoute: (lastFailedRoute: string | undefined) =>
    set({ lastFailedRoute }),

  authState: null,
  setAuthState: (authState: AuthState) => set({ authState }),

  privileges: [],
  setPrivilege: (privileges: string[]) => set({ privileges }),
}));

export const useAuthStore = authStore;
